import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

import { SanityResult } from './time-entry-sanity'

export interface TimeEntrySanityCheckModalData extends SanityResult {
    /** 'add' | 'edit' — controls verbiage on the action button */
    action: 'add' | 'edit'
}

export interface TimeEntrySanityCheckModalResult {
    proceed: boolean
}

@Component({
    selector: 'app-time-entry-sanity-check-modal',
    templateUrl: './time-entry-sanity-check-modal.component.html',
    styleUrls: ['./time-entry-sanity-check-modal.component.scss'],
    standalone: false
})
export class TimeEntrySanityCheckModalComponent {
    constructor(
        private dialogRef: MatDialogRef<TimeEntrySanityCheckModalComponent, TimeEntrySanityCheckModalResult>,
        @Inject(MAT_DIALOG_DATA) public data: TimeEntrySanityCheckModalData
    ) {}

    get durationLabel(): string {
        const hours = this.data.durationHours
        if (hours === null) return ''
        if (hours >= 24) {
            const days = Math.floor(hours / 24)
            const remHours = Math.round((hours - days * 24) * 10) / 10
            return remHours > 0 ? `${days}d ${remHours}h` : `${days}d`
        }
        return `${Math.round(hours * 10) / 10}h`
    }

    get startDateDisplay(): string {
        return this.formatDateKey(this.data.startDateLabel)
    }

    get endDateDisplay(): string {
        return this.formatDateKey(this.data.endDateLabel)
    }

    private formatDateKey(key: string | null): string {
        if (!key) return ''
        const [y, m, d] = key.split('-').map(Number)
        if (!y || !m || !d) return key
        const date = new Date(y, m - 1, d)
        return date.toLocaleDateString([], { weekday: 'short', month: 'short', day: 'numeric' })
    }

    get continueLabel(): string {
        return this.data.action === 'edit' ? 'Save Anyway' : 'Add Anyway'
    }

    onCancel(): void {
        this.dialogRef.close({ proceed: false })
    }

    onContinue(): void {
        this.dialogRef.close({ proceed: true })
    }
}
